import { render, staticRenderFns } from "./entrust.vue?vue&type=template&id=779e4589&scoped=true"
import script from "./entrust.vue?vue&type=script&lang=js"
export * from "./entrust.vue?vue&type=script&lang=js"
import style0 from "./entrust.vue?vue&type=style&index=0&id=779e4589&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779e4589",
  null
  
)

export default component.exports